module.exports = __webpack_public_path__ + "static/img/introduce_icon2.78d398a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/VXImage/introduce_icon2.svg
// module id = Yo2Y
// module chunks = 0